<template>
  
    <div class="actual_score_container">

        <div class="actual_score_left">
            <div class="actual_score_title">
                <h3 class="actual_first">{{ score_data.def_text.title }}</h3>
            </div>

            <div class="actual_progress_wrapper">
                <div class="actual_progress_back">
                    <div class="actual_progress_container">
                        <div class="ref_value" :style="{left: ref_padding }">
                            <span>{{ ref_score }}</span>
                        </div>
                        
                        <div class="actual_progress_active_container">
                            <div class="actual_progress_active" :style="{width: bar_width }">
                                <span class="score_bar">{{ score_label }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="actual_score_right">
            <div class="actual_score_def">
                {{ score_data.def_text.definition }}
            </div>
        </div>
    </div>
        
</template>

<script>


export default {
    name: 'ActualScore2',
    props: ['score_data'],
    components: {
        
    },
    mounted() {},
    data(){
        return {}
    },
    computed: {
        bar_width(){
            let score = this.score_data.score * 100 / 5
            return score + '%'
        },
        ref_padding(){
            let score = this.score_data.ref_score * 100 / 5
            return score + '%'
        },
        score_label(){
            let score = this.score_data.score * 100 / 5
            return score.toFixed(0) + '/100'
        },
        ref_score(){
            let score = this.score_data.ref_score * 100 / 5
            return score.toFixed(0)
        },
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.actual_score_container{
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    .actual_score_left{

    }
    .actual_score_right{
        padding-left: 20px;
    }

    .actual_score_title{
        text-align: left;
        h3.actual_first{
            font-size: 1.6rem;
            font-weight: 500;
        }
        h3.actual_first::first-letter{
            color: #e40521;
            font-size: 130%;
            font-weight: 800;
    
        }
    }
    .actual_score_def{
        text-align: justify;
        font-size: 1.1rem;
        margin-top: 34px;
        line-height: 1.4rem;
    }
    .actual_progress_wrapper{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 0 6px;
        .actual_progress_back{
            border-radius: 100px;
            background: #d3d3d3;
            width: 354px;
            height: 43px;
            padding: 1px;
            box-shadow: 2px 5px 12px rgb(207, 207, 207);
            .actual_progress_container{
                position: relative;
                // overflow: hidden;
                border-radius: 100px;
                background: whitesmoke;
                width: 350px;
                height: 40px;
                padding: 5px;
                .ref_value{
                    position: absolute;
                    height:30px;
                    width: 4px;
                    background-color: #e40521;
                    left: 50%;
                    span{
                        font-weight: 500;
                        margin-top: 40px;
                        display: block;
                        color: #e40521;
                        margin-left: -8px;
                    }
                }
            }
            .actual_progress_active_container{
                height: 100%;
                border-radius: 100px;
                background: #d9d9d9;
                box-shadow: inset 0 0 10px #b5b5b5;
                .actual_progress_active{
                    height: 100%;
                    border-radius: 100px;
                    background: #545352;                    
                    display: flex;
                    align-items: center;
                    padding-left: 12px;
                    padding-top: 2px;
                    .score_bar{
                        color: white;
                        font-weight: 600;
                    }
            
                }
            }
        }
    }
}



</style>
